<script lang="ts">
  import '../app.postcss'
  import Header from '$components/LayoutElements/Header.svelte'
  import Footer from '$components/LayoutElements/Footer.svelte'
  import { onNavigate } from '$app/navigation'
  import type { LayoutData } from './$types'
  import Loading from '$components/LayoutElements/Loading.svelte'
  import { showLoading } from '$lib/stores/layout'
  import { ModeWatcher } from 'mode-watcher'
  import { Toaster } from '$lib/components/ui/sonner'
  import Analytics from '$lib/components/analytics.svelte'
  import { env } from '$env/dynamic/public'

  export let data: LayoutData

  onNavigate((navigation) => {
    // @ts-ignore
    if (!document.startViewTransition) return

    return new Promise((resolve) => {
      // @ts-ignore
      document.startViewTransition(async () => {
        resolve()
        await navigation.complete
      })
    })
  })
</script>

<Analytics />

<svelte:head>
  <link data-senna-track="temporary" href={`${env.PUBLIC_URL}/es`} rel="canonical" />
  <link data-senna-track="temporary" href={`${env.PUBLIC_URL}/es`} hreflang="x-default" rel="alternate" />
  <link data-senna-track="temporary" href={`${env.PUBLIC_URL}/es`} hreflang="es" rel="alternate" />
  <link data-senna-track="temporary" href={`${env.PUBLIC_URL}/en`} hreflang="en" rel="alternate" />
  <link data-senna-track="temporary" href={`${env.PUBLIC_URL}/fr`} hreflang="fr" rel="alternate" />
  <link data-senna-track="temporary" href={`${env.PUBLIC_URL}/it`} hreflang="it" rel="alternate" />
  <link data-senna-track="temporary" href={`${env.PUBLIC_URL}/de`} hreflang="de" rel="alternate" />
</svelte:head>

{#if data.useLayout}
  <div class="min-h-screen flex flex-col">
    <Header user={data.user} />
    <main class="flex flex-1 flex-col overflow-y">
      <slot />
    </main>
    <Footer />
  </div>
{:else}
  <slot />
{/if}

<Loading show={$showLoading} />

<ModeWatcher defaultMode={'light'} />

<Toaster richColors closeButton />
